// 热播剧演员表（演示性策划内容）
export const dramas = [
  {
    id: "seoul-platform",
    title: "首尔月台",
    genre: "爱情 / 都市",
    year: "2025",
    network: "tvN 水木剧",
    episodes: "16 集",
    rating: "12.4%",
    heat: 9821,
    badge: "本季热度第一",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20Korean%20drama%20poster%20art%2C%20lonely%20train%20platform%20at%20dusk%20with%20amber%20lamp%20light%20and%20soft%20rain%2C%20empty%20tracks%20stretching%20into%20a%20pastel%20sunset%20sky%2C%20editorial%20illustration%20style%2C%20muted%20coral%20and%20cream%20palette%2C%20romantic%20melancholy%20mood%2C%20minimal%20negative%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-01&orientation=portrait",
    synopsis:
      "两名在深夜月台错过末班车的上班族，用一张张旧车票拼起十年的暗恋。故事以首尔四座老车站为章节，记录普通人的重逢与告白。",
    cast: [
      { role: "尹夏琳", actor: "车瑞妍", note: "女一号 · 车站广播员" },
      { role: "姜志勋", actor: "李道勋", note: "男一号 · 深夜代驾司机" },
      { role: "吴敏贞", actor: "吴世琳", note: "女二号 · 夏琳的同事" },
      { role: "韩在赫", actor: "郑宇彬", note: "特别出演 · 站长" },
      { role: "尹正浩", actor: "徐河准", note: "夏琳的弟弟" },
      { role: "朴惠珍", actor: "罗美淑", note: "夏琳的母亲" },
    ],
  },
  {
    id: "north-of-han",
    title: "汉江以北",
    genre: "悬疑 / 犯罪",
    year: "2025",
    network: "JTBC 金土剧",
    episodes: "12 集",
    rating: "9.8%",
    heat: 8710,
    badge: "口碑黑马",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20Korean%20crime%20thriller%20poster%20art%2C%20rainy%20night%20cityscape%20of%20Seoul%20with%20glowing%20street%20lamps%20and%20wet%20asphalt%20reflections%2C%20a%20lone%20silhouette%20in%20a%20trench%20coat%2C%20deep%20warm%20charcoal%20and%20amber%20tones%2C%20gritty%20editorial%20illustration%2C%20dramatic%20shadows%2C%20cinematic%20composition%20with%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-02&orientation=portrait",
    synopsis:
      "一起十年前的悬案随着汉江水位下降重见天日。退休刑警与年轻检察官跨越新老城区，追查一条被刻意抹去的证据链。",
    cast: [
      { role: "具本镇", actor: "郑宇彬", note: "男一号 · 退休刑警" },
      { role: "申睿恩", actor: "裴书俊", note: "女一号 · 检察官" },
      { role: "高成宰", actor: "权敏俊", note: "警队队长" },
      { role: "李花英", actor: "金慕妍", note: "法医" },
      { role: "崔民秀", actor: "姜泰允", note: "目击者" },
    ],
  },
  {
    id: "four-seasons-diner",
    title: "四季食堂",
    genre: "治愈 / 家庭",
    year: "2024",
    network: "tvN 周末剧",
    episodes: "20 集",
    rating: "14.1%",
    heat: 8240,
    badge: "年度收视王",
    poster:
      "https://readdy.ai/api/search-image?query=Cozy%20Korean%20healing%20drama%20poster%20art%2C%20tiny%20neighborhood%20diner%20interior%20with%20warm%20hanging%20bulbs%20and%20steaming%20homemade%20dishes%20on%20a%20wooden%20table%2C%20seasonal%20plants%20by%20the%20window%2C%20soft%20cream%20and%20terracotta%20palette%2C%20gentle%20editorial%20illustration%2C%20inviting%20nostalgic%20mood%2C%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-03&orientation=portrait",
    synopsis:
      "一家只做当季食材的小食堂，四个女儿轮流掌勺。每一集用一道家常菜，讲一段关于离别、和解与归来的家庭故事。",
    cast: [
      { role: "吴顺子", actor: "罗美淑", note: "母亲 · 食堂主厨" },
      { role: "吴夏恩", actor: "金慕妍", note: "长女 · 返乡继承" },
      { role: "吴冬美", actor: "韩素珍", note: "三女 · 美食编辑" },
      { role: "姜社长", actor: "权敏俊", note: "街角杂货店老板" },
      { role: "小白", actor: "柳智安", note: "打工生" },
    ],
  },
  {
    id: "golden-empire",
    title: "黄金帝国",
    genre: "商战 / 复仇",
    year: "2025",
    network: "SBS 月火剧",
    episodes: "24 集",
    rating: "11.6%",
    heat: 7960,
    badge: "话题争议作",
    poster:
      "https://readdy.ai/api/search-image?query=Luxurious%20Korean%20business%20revenge%20drama%20poster%20art%2C%20corporate%20boardroom%20with%20floor%20to%20ceiling%20windows%20overlooking%20a%20glittering%20city%20at%20night%2C%20marble%20table%20and%20golden%20lamps%2C%20rich%20deep%20burgundy%20and%20brass%20palette%2C%20elegant%20editorial%20illustration%2C%20cold%20power%20atmosphere%2C%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-04&orientation=portrait",
    synopsis:
      "被逐出家门的私生子带着一份三十年前的账本归来，逐层拆解庞大的家族财阀。金钱、亲缘与忠诚，在董事会上被反复称重。",
    cast: [
      { role: "姜泰成", actor: "姜泰允", note: "男一号 · 归来者" },
      { role: "白智熙", actor: "白智熙", note: "女一号 · 法务总监" },
      { role: "姜会长", actor: "郑宇彬", note: "财阀家长" },
      { role: "具秘书", actor: "徐河准", note: "会长的心腹" },
      { role: "姜敏雅", actor: "吴世琳", note: "嫡系小女儿" },
    ],
  },
  {
    id: "jeju-snow",
    title: "济州岛的雪",
    genre: "爱情 / 剧情",
    year: "2024",
    network: "Netflix 原创",
    episodes: "10 集",
    rating: "—",
    heat: 7380,
    badge: "口碑治愈",
    poster:
      "https://readdy.ai/api/search-image?query=Serene%20Korean%20romance%20drama%20poster%20art%2C%20snow%20covered%20Jeju%20island%20stone%20wall%20and%20tangerine%20trees%2C%20a%20small%20guesthouse%20with%20smoke%20from%20the%20chimney%2C%20pale%20winter%20sky%20with%20soft%20falling%20snow%2C%20muted%20dusty%20rose%20and%20warm%20grey%20palette%2C%20quiet%20editorial%20illustration%2C%20tender%20mood%2C%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-05&orientation=portrait",
    synopsis:
      "一位首尔的大提琴手搬到济州岛疗养，与经营橘子农场的旧友重逢。用一整个冬天，学会与未完成的告别和解。",
    cast: [
      { role: "尹诗雅", actor: "车瑞妍", note: "女一号 · 大提琴手" },
      { role: "朴润宰", actor: "李道勋", note: "男一号 · 农场主" },
      { role: "姜奶奶", actor: "罗美淑", note: "民宿房东" },
      { role: "小李", actor: "柳智安", note: "民宿管家" },
    ],
  },
  {
    id: "ward-nine",
    title: "九号病房",
    genre: "医疗 / 群像",
    year: "2025",
    network: "tvN 月火剧",
    episodes: "16 集",
    rating: "10.2%",
    heat: 7020,
    badge: "新人气剧",
    poster:
      "https://readdy.ai/api/search-image?query=Thoughtful%20Korean%20medical%20drama%20poster%20art%2C%20quiet%20hospital%20corridor%20at%20dawn%20with%20warm%20light%20spilling%20through%20half%20open%20blinds%2C%20empty%20wheelchair%20and%20a%20nurse%20station%20green%20plant%2C%20soft%20sage%20and%20cream%20palette%2C%20clean%20editorial%20illustration%2C%20calm%20hopeful%20mood%2C%20space%20for%20title%20text&width=600&height=850&seq=hd-drama-06&orientation=portrait",
    synopsis:
      "九号病房收治的都是被其它科室婉拒的疑难病人。三位年轻医生在挽救生命的同时，也重新学习如何面对无能为力。",
    cast: [
      { role: "徐智勋", actor: "徐河准", note: "男一号 · 住院医" },
      { role: "韩素贞", actor: "韩素珍", note: "女一号 · 主治医师" },
      { role: "吴世琳", actor: "吴世琳", note: "护理组长" },
      { role: "裴主任", actor: "裴书俊", note: "科室主任" },
      { role: "李实习生", actor: "柳智安", note: "实习生" },
    ],
  },
];

// 类型筛选项
export const dramaGenres = [
  "全部",
  "爱情 / 都市",
  "悬疑 / 犯罪",
  "治愈 / 家庭",
  "商战 / 复仇",
  "医疗 / 群像",
];